import { Location } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';

import { StoryService } from '../../create-story/story.service';

import { InitialStoryPhotoArray, PhotoObject } from '../../create-story/images-holder/story-photos';

@Component({
  selector: 'app-add-story-dialog',
  standalone: true,
  imports: [],
  templateUrl: './add-story-dialog.component.html',
  styleUrl: './add-story-dialog.component.scss'
})
export class AddStoryDialogComponent {
  @ViewChild('fileUpload') fileUpload!: ElementRef;
  
  storyImages: PhotoObject[] = []
  photos = JSON.parse(JSON.stringify([...InitialStoryPhotoArray])) // TODO: copy of a copy? 
  resizeImage = false;
  constructor(
    private location: Location,
    private storyService: StoryService,
    private router: Router,
    private imageCompress: NgxImageCompressService
  ){}

  closeDialog(){
    this.location.back()
  }

  openFileInput() {
    this.fileUpload.nativeElement.click();
  }

  drop(ev: DragEvent) {
    if (!ev.dataTransfer) return
    //stops browser from opening the file
    ev.preventDefault()
    
    if (ev.dataTransfer!.files.length > 0) {
      const reader: FileReader = new FileReader()

      reader.readAsDataURL(ev.dataTransfer!.files[0])
      let fileUrl = ''
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      reader.onload = (imgSrc: any) => {
        fileUrl = imgSrc.target.result

        this.photos[0].src = fileUrl
        this.storyService.storyImages.next(this.photos)
      
        if (ev.dataTransfer?.items && fileUrl === '') {
          // Use DataTransferItemList interface to access the file(s)
          for (const item of ev.dataTransfer.items) {
            if (item.kind !== 'file') {
              return
            }
  
            const file = item.getAsFile()
  
            if (!file) return
            const fileBlob = URL.createObjectURL(file)

            console.log(file)
  
            this.photos[0].src = fileBlob
            this.storyService.storyImages.next(this.photos)
          }
        } else if(fileUrl === ''){
          // Use DataTransfer interface to access the file(s)
          for (const file of ev.dataTransfer!.files) {
            const fileBlob = URL.createObjectURL(file)

            this.photos[0].src = fileBlob
            this.storyService.storyImages.next(this.photos)
          }
        }
      
        //this.router.navigate(['create-story'])
      }
    }
  }

  allowDrop(ev: DragEvent) {
    ev.preventDefault()
    //console.log('allowDrop:', ev)
  }

  // image added via the explorer
  onPhotoOrVideoInputChange(event: Event) {
    console.log('photo selection')
    const fileInput = event.currentTarget as HTMLInputElement

    if(!fileInput) return
    if(!fileInput.files) return

    const imageFile = fileInput.files[0]
    const reader = new FileReader() 
    
    reader.onload = (e: ProgressEvent<FileReader>) => {     
      const thumbnail = new Image()
      const img = new Image()
        img.onload = () => {

        this.resizeImage = true
        if(this.storyImages.length){
          this.storyImages[0].src = img.src
        } else {
          this.storyImages.push({src: img.src, saved: false, disabled: false})
        }
        
        this.storyService.currentPhoto.next({src: img.src})
        this.photos[0].src = img.src
      }

      img.src = e.target?.result as string

      // create a thumbnail version of the image for the images holder
      this.imageCompress.compressFile(e.target?.result as string, DOC_ORIENTATION.Default, 100, 100, 100, 100).then((r)=>{
        thumbnail.src = r
        if(this.storyImages.length){
          this.storyImages[0].thumbnailSrc = thumbnail.src
        } else {
          this.storyImages.push({thumbnailSrc: thumbnail.src, saved: false, disabled: false})
        }

        console.log(this.storyImages)
        this.storyService.storyImages.next(this.storyImages)
        this.router.navigate(['create-story'])
      })
    }
    
    reader.onloadend = () => {}
    reader.readAsDataURL(imageFile)
  }
}